module.exports = __webpack_public_path__ + "img/500.92dfcef6.svg";